import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Page, MobileContainer } from '@containers/layout';
import { IconButton, Box, Text, Heading } from '@components/common';
import useDetectSize from '@hooks/useDetectSize';
import FullScreenLoader from '@components/loading/FullScreenLoader';

import {
  BillingHistoryDetail,
  BillingHistoryTable
} from '@containers/billings';
import history from '@utils/history';

import BillingHistoryActions, {
  BillingHistorySelectors
} from '@redux/BillingHistoryRedux';

function BillingHistoryPage(props) {
  const { loadBillingHistory, billingList, loading } = props;
  const isMobile = useDetectSize();

  useEffect(() => {
    loadBillingHistory();
  }, []);

  const goBack = () => {
    history.goBack();
  };

  const hasNoHistory = !billingList || !billingList.length;

  const renderMobileLayout = () => {
    return (
      <MobileContainer pt={4}>
        <Box flex={1} display="flex" flexDirection="column">
          <Heading>Payment History</Heading>
          {hasNoHistory && <Text mt={5}>No active payment history</Text>}
          {!hasNoHistory && <BillingHistoryDetail />}
        </Box>
      </MobileContainer>
    );
  };

  const renderDesktopLayout = () => {
    return (
      <Box flex={1} alignSelf="stretch" py={5} px={7}>
        <Box flex={1} display="flex" flexDirection="column">
          <Heading>Payment History</Heading>
          {hasNoHistory && <Text mt={5}>No active payment history</Text>}
          {!hasNoHistory && <BillingHistoryTable />}
        </Box>
      </Box>
    );
  };

  const renderBackButton = () => {
    return (
      <IconButton
        onClick={goBack}
        name="back"
        width={16}
        height={16}
        title="Back"
      />
    );
  };

  if (loading) {
    return <FullScreenLoader />;
  }

  return (
    <Page title="History" renderHeaderLeftButtons={renderBackButton}>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </Page>
  );
}

BillingHistoryPage.propTypes = {
  loading: PropTypes.bool,
  loadBillingHistory: PropTypes.func,
  billingList: PropTypes.array
};

const mapStatesToProps = state => ({
  loading: BillingHistorySelectors.selectLoading(state),
  billingList: BillingHistorySelectors.selectBillingHistory(state)
});

const mapDispatchToProps = dispatch => ({
  loadBillingHistory: () =>
    dispatch(BillingHistoryActions.setBillingHistoryLoadRequest())
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(BillingHistoryPage);
